"use client";

import { useState } from "react";
import Link from "next/link";
import { DOCS_INDEX } from "@/app/(marketing)/docs/search-index";

export default function DocsSearch() {
  const [query, setQuery] = useState("");

  const results =
    query.length === 0
      ? []
      : DOCS_INDEX.filter((item) =>
          item.title.toLowerCase().includes(query.toLowerCase()) ||
          item.keywords?.some((k) =>
            k.toLowerCase().includes(query.toLowerCase())
          )
        );

  return (
    <div className="mb-6">
      <input
        type="text"
        placeholder="Search docs…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />

      {query && results.length > 0 && (
        <ul className="mt-2 rounded-md border bg-white shadow-sm">
          {results.map((item) => (
            <li key={item.href}>
              <Link
                href={item.href}
                className="block px-3 py-2 text-sm hover:bg-gray-100"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      )}

      {query && results.length === 0 && (
        <p className="mt-2 text-xs text-gray-500">No results found</p>
      )}
    </div>
  );
}
